import React from 'react';
import * as utils from "../../../utils/utils";
import {Chip} from "react-materialize";

export default class Commodities extends React.Component {
    render() {
        return (
            <span>
                {utils.notNullNorUndefined(this.props.row.commodities) && this.props.row.commodities.map((item, index) => (
                    <span key={index}><Chip className="chip">{item}</Chip><br/></span>
                ))}
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/tableComponents/Commodities.js